import Vue from 'vue'
import { instance, errorService } from '@/services/api'
import { userAPIs, settingAPIs } from '@/services/authConstantsV1'
import axios from 'axios'

export default {
  name: 'Loading',

  created() {
    this.getToken()
  },
  methods: {
    async getToken() {
      if (
        this.$route.params.route !== undefined &&
        this.$route.params.route.fullPath.indexOf('access_denied') >= 0
      ) {
        this.$router.push({
          name: 'unauthorized',
          params: {
            loaded: true,
          },
        })
      } else {
        const accessToken = await this.$auth.getAccessToken()

        if (!accessToken) {
          const currentUrl = this.$route.params.route
          const redirectURL = sessionStorage.getItem('redirectUrl')

          sessionStorage.setItem(
            'redirectUrl',
            JSON.stringify(redirectURL || currentUrl),
          )

          this.$auth.loginRedirect()
        } else {
          Promise.all([
            this.loadUserDetails(),
            this.loadAppSettings(),
            this.loggedInUser(),
          ])
            .then(
              axios.spread((...responses) => {
                // Start the Web Socket
                Vue.prototype.startSocket(accessToken)
                localStorage.setItem(
                  'userDetails',
                  JSON.stringify(responses[0].data.result),
                )
                localStorage.setItem(
                  'userSettings',
                  JSON.stringify(responses[1].data.result),
                )
                localStorage.setItem('isLogin', true)
                let redirectURL = sessionStorage.getItem('redirectUrl')
                if (
                  redirectURL &&
                  redirectURL !== 'undefined' &&
                  redirectURL !== 'null'
                ) {
                  redirectURL = JSON.parse(redirectURL)
                } else {
                  redirectURL = undefined
                }
                if (
                  redirectURL &&
                  redirectURL !== '/' &&
                  redirectURL !== 'null' &&
                  redirectURL !== undefined &&
                  redirectURL !== 'undefined'
                ) {
                  const toRoute = redirectURL
                  toRoute.params.loaded = true
                  this.$router.push(toRoute)
                  sessionStorage.removeItem('redirectUrl')
                } else if (this.$route.params.route !== undefined) {
                  const toRoute = this.$route.params.route
                  toRoute.params.loaded = true
                  this.$router.push(toRoute)
                } else {
                  this.$router.push({
                    name: 'dashboard',
                    params: {
                      loaded: true,
                    },
                  })
                }
                this.loadVersionSetting()
              }),
            )
            .catch(errors => {
              errorService(errors, this.$router)
            })
        }
      }
    },

    loadUserDetails() {
      return instance.get(userAPIs.details)
    },

    loadAppSettings() {
      return instance.get(settingAPIs.getSetting)
    },

    loggedInUser() {
      const isLogin = localStorage.getItem('isLogin')
      if (!isLogin) {
        return instance.get(userAPIs.login)
      }
    },

    loadVersionSetting() {
      const settings = JSON.parse(localStorage.getItem('userSettings'))
      const buildVersion = settings.application.buildVersion
      const userDetails = JSON.parse(localStorage.getItem('userDetails'))
      if (userDetails.buildVersion !== buildVersion) {
        const h = this.$createElement
        this.$info({
          title: () => 'A new version of Cost Segregation is released',
          content: h('div', {}, [
            h('p', `Cost Segregation version ${buildVersion} is released.`),
            h('p', {}, [
              'Please press ',
              h('kbd', 'Ctrl'),
              ' + ',
              h('kbd', 'Shift'),
              ' + ',
              h('kbd', 'R'),
              ' to get the latest updates.',
            ]),
          ]),
          centered: true,
          onOk() {
            const request = {
              buildVersion: buildVersion,
            }
            instance
              .patch(userAPIs.updateBuildVersion, request)
              .then(res => {
                localStorage.removeItem('userDetails')
                userDetails.buildVersion = buildVersion
                localStorage.setItem(
                  'userDetails',
                  JSON.stringify(userDetails),
                )
              })
              .catch(err => {
                errorService(err)
              })
          },
        })
      }
    },
  },
}
